import en from './en.json';
import uk from './uk.json';
import pl from './pl.json';
import ru from './ru.json';
import es from './es.json';
import uz from './uz.json';
import hi from './hi.json';
import { createLocale } from '../../utils.js';

const locales = {
  en: createLocale(en, 'users'),
  uk: createLocale(uk, 'users'),
  pl: createLocale(pl, 'users'),
  ru: createLocale(ru, 'users'),
  es: createLocale(es, 'users'),
  uz: createLocale(uz, 'users'),
  hi: createLocale(hi, 'users'),
};

export default locales;
